import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataGridComponent, GridColumn, GridConfig } from '../../shared/data-grid/data-grid.component';
import { MaterialModule } from '../../material.module';

@Component({
    selector: 'app-notes-dialog',
    templateUrl: './notes-dialog.component.html',
    styleUrls: ['./notes-dialog.component.css'],
    imports: [CommonModule, DataGridComponent, MaterialModule],
})
export class NotesDialogComponent {
    notesColumns: GridColumn[] = [
        { key: 'notes', label: 'Notes', sortable: true, width: '350px' },
        { key: 'projectName', label: 'Project Name', sortable: true, width: '200px' },
        { key: 'notesStartDate', label: 'Start date', sortable: true, width: '100px', accessor: (row) => row.notesStartDate ? new Date(row.notesStartDate).toLocaleDateString() : '' },
        { key: 'notesEndDate', label: 'End date', sortable: true, width: '100px', accessor: (row) => row.notesEndDate ? new Date(row.notesEndDate).toLocaleDateString() : '' },
        { key: 'addedBy', label: 'Added By', sortable: true, width: '250px' },
    ];

    gridConfig: GridConfig = {
        pageSize: 10,
        pageSizeOptions: [10, 20, 50],
        showFirstLastButtons: true,
        showColumnFilters: true,
        enableSorting: true,
        stickyHeader: true,
    };
    constructor(
        public dialogRef: MatDialogRef<NotesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any[]
    ) { }

    close() {
        this.dialogRef.close();
    }
}